/**
 * Created by rickborst on 25/04/2017.
 */

import _ from 'lodash';

/**
 * Converts tag data from read data.
 *
 * @param {Object} [data] - Read data.
 * @returns {Object} Tag data.
 */
export function convertFromRead (data = {}) {

    return {
        genres: _.map(_.get(data, ['genre', 'objects']) || [], genreData => {

            return genreData.value;
        })
    };
}


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/adapters/assets/tags.js